module.exports = __webpack_public_path__ + "img/academy.6f58ad65.png";